import {
  AcompanhamentoCondicaoSaudeTematicaEnum,
  ExameRealizadoPreNatalConsolidadoStatusEnum,
  FaixaEtariaEnum,
} from 'graphql/types.generated'
import { isEmpty } from 'util/validation/Util'
import { hasFaixaEtariaRange } from 'view/acompanhamento/model/model-acompanhamentoFilter'

import {
  AcompanhamentoCondicaoSaudeFiltrosAvancadosModel,
  AcompanhamentoCondicaoSaudeFormModel,
} from './model/model-acompanhamentoCondicaoSaude'

export const labelByStatus = (status?: ExameRealizadoPreNatalConsolidadoStatusEnum): string =>
  status ? statusToText[status] : statusInvalidoText

const statusToText: Record<ExameRealizadoPreNatalConsolidadoStatusEnum, string> = {
  [ExameRealizadoPreNatalConsolidadoStatusEnum.SIM]: 'Sim',
  [ExameRealizadoPreNatalConsolidadoStatusEnum.NAO]: 'Não',
  [ExameRealizadoPreNatalConsolidadoStatusEnum.NAO_SE_APLICA]: 'Não se aplica',
}

const statusInvalidoText = '-'

export function contarFiltrosAvancadosAplicados(filter: AcompanhamentoCondicaoSaudeFormModel) {
  const { filtrosAvancados, tematica } = filter ?? {}

  const filtrosDaModal: AcompanhamentoCondicaoSaudeFiltrosAvancadosModel = {
    periodoUltimoAtendimento:
      filtrosAvancados?.periodoUltimoAtendimento &&
      (filtrosAvancados.periodoUltimoAtendimento.startDate || filtrosAvancados.periodoUltimoAtendimento.endDate)
        ? filtrosAvancados.periodoUltimoAtendimento
        : null,
    grupoCondicao: !isEmpty(filtrosAvancados?.grupoCondicao) ? filtrosAvancados?.grupoCondicao : null,
    problemasCondicoes: !isEmpty(filtrosAvancados?.problemasCondicoes) ? filtrosAvancados?.problemasCondicoes : null,
    ativoListaProblema: filtrosAvancados?.ativoListaProblema || null,
    naoIncluidoListaProblema: filtrosAvancados?.naoIncluidoListaProblema || null,
    sexo: !isEmpty(filtrosAvancados?.sexo) ? filtrosAvancados?.sexo : null,
    tipoFaixaEtaria:
      filtrosAvancados?.tipoFaixaEtaria && filtrosAvancados.tipoFaixaEtaria !== FaixaEtariaEnum.OUTRA
        ? filtrosAvancados?.tipoFaixaEtaria
        : null,
    faixaEtariaRange: hasFaixaEtariaRange(filtrosAvancados?.faixaEtariaRange)
      ? filtrosAvancados?.faixaEtariaRange
      : null,
    identidadeGenero: !isEmpty(filtrosAvancados?.identidadeGenero) ? filtrosAvancados?.identidadeGenero : null,
    ivcf: filtrosAvancados?.ivcf ?? undefined,
    racaCor: filtrosAvancados?.racaCor ?? null,
    condicaoMaternal: filtrosAvancados?.condicaoMaternal ?? null,
    beneficiarioBolsaFamilia: filtrosAvancados?.beneficiarioBolsaFamilia ?? null,
  }

  const currentFiltrosAplicados: AcompanhamentoCondicaoSaudeFiltrosAvancadosModel =
    tematica === AcompanhamentoCondicaoSaudeTematicaEnum.GERAL
      ? { beneficiarioBolsaFamilia: filtrosDaModal.beneficiarioBolsaFamilia }
      : filtrosDaModal

  const countFiltrosAplicados = Object.values(currentFiltrosAplicados).reduce<number>((count, value) => {
    if (Array.isArray(value) && value.length > 0) {
      return count + value.length
    }
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      Object.values(value).some((v) => Array.isArray(v) && v.length > 0)
    ) {
      return count + Object.values(value).reduce<number>((acc, v) => (Array.isArray(v) ? acc + v.length : acc), 0)
    }
    if (!Array.isArray(value) && !isEmpty(value)) {
      return count + 1
    }
    return count
  }, 0)

  return countFiltrosAplicados
}

export function getProcedimentosConsideradosTooltipText(
  procedimentos: string[],
  title?: { plural: string; singular: string }
): string {
  if (isEmpty(procedimentos)) return ''

  const { plural = 'Procedimentos considerados', singular = 'Procedimento considerado' } = title ?? {}
  const actualTitle = procedimentos.length > 1 ? plural : singular

  return `${actualTitle}:\n${procedimentos.join('\n\n')}`
}

export const hasGrupoCondicaoOrCidCiap = (filtros: AcompanhamentoCondicaoSaudeFiltrosAvancadosModel) =>
  (filtros?.grupoCondicao?.length ?? 0) > 0 || (filtros?.problemasCondicoes?.length ?? 0) > 0

export const isProblemaAtivoOuNaoIncluido = (filtros: AcompanhamentoCondicaoSaudeFiltrosAvancadosModel) =>
  filtros?.ativoListaProblema || filtros?.naoIncluidoListaProblema
